import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PatientService } from '@services/patient.service';
import { ClinicReportDetailsViewModel } from './../../../../services/reports.service';

@Component({
  selector: 'app-sales-summary-details',
  templateUrl: './sales-summary-details.component.html',
  styleUrls: ['./sales-summary-details.component.less'],
})
export class SalesSummaryDetailsComponent {
  loading: boolean = false;
  @Input() salesDetails: ClinicReportDetailsViewModel[] = [];

  constructor(private router: Router, private patientService: PatientService) {}

  navigateToPatientInvoice(patientId: number, invoiceId: number) {
    this.patientService.getPatientById(patientId).subscribe((patient: any) => {
      this.patientService.patientPanelPatient = patient;
      this.router.navigate([
        '/reports',
        {
          outlets: {
            'action-panel': [
              'patient',
              patientId + '_patientprofiletab',
              'patienttabs',
              'patientaccounttab',
              'invoice',
              invoiceId,
            ],
          },
        },
      ]);
    });
  }
}
